export default "__VITE_ASSET__CfM3UAjw__"